"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _IconConstants = require("../icon/IconConstants");

var _iconName = require("../utils/propTypes/iconName");

var _Functions = require("../core/Functions");

var _default = _react.default.createClass({
  displayName: "UIIconToggle",
  propTypes: {
    'aria-label': _propTypes.default.string.isRequired,
    checked: _propTypes.default.bool,
    checkedColor: _propTypes.default.string,
    checkedIcon: (0, _iconName.getIconNamePropType)(),
    disabled: _propTypes.default.bool,
    defaultChecked: _propTypes.default.bool,
    iconSize: _propTypes.default.oneOf(Object.keys(_IconConstants.ICON_SIZES)),
    onChange: _propTypes.default.func,
    percentFilled: _propTypes.default.number,
    readOnly: _propTypes.default.bool,
    uncheckedColor: _propTypes.default.string,
    uncheckedIcon: (0, _iconName.getIconNamePropType)(),
    _tabbable: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      checkedIcon: 'favorite',
      uncheckedIcon: 'favoriteHollow',
      checkedColor: _colors.MARIGOLD,
      uncheckedColor: _colors.FLINT,
      iconSize: 'xs',
      _tabbable: true
    };
  },
  getInitialState: function getInitialState() {
    var _this$props = this.props,
        checked = _this$props.checked,
        defaultChecked = _this$props.defaultChecked;
    return {
      checked: checked || defaultChecked || false
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(_ref) {
    var checked = _ref.checked;

    if (checked !== this.state.checked) {
      this.setState({
        checked: checked
      });
    }
  },
  handleChange: function handleChange(evt) {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        onChange = _this$props2.onChange,
        readOnly = _this$props2.readOnly;
    var checked = evt.target.checked;

    if (disabled || readOnly) {
      evt.preventDefault();
      return;
    }

    if (!this.props.hasOwnProperty('checked')) {
      this.setState({
        checked: checked
      });
    }

    (0, _Functions.callIfPossible)(onChange, evt);
  },
  renderForegroundIcon: function renderForegroundIcon(_ref2, _ref3) {
    var checkedColor = _ref2.checkedColor,
        checkedIcon = _ref2.checkedIcon,
        iconSize = _ref2.iconSize,
        percentFilled = _ref2.percentFilled;
    var hasPercentage = _ref3.hasPercentage;

    if (!hasPercentage) {
      return null;
    }

    return _react.default.createElement(_UIIcon.default, {
      className: (0, _classnames.default)('private-form__icon-toggle__foreground-icon', 'private-form__icon-toggle__icon'),
      color: checkedColor,
      name: checkedIcon,
      role: "presentation",
      size: iconSize,
      style: {
        width: percentFilled / 100 + "em"
      }
    });
  },
  render: function render() {
    var _this$props3 = this.props,
        ariaLabel = _this$props3['aria-label'],
        checked = _this$props3.checked,
        checkedColor = _this$props3.checkedColor,
        checkedIcon = _this$props3.checkedIcon,
        className = _this$props3.className,
        defaultChecked = _this$props3.defaultChecked,
        __disabled = _this$props3.disabled,
        iconSize = _this$props3.iconSize,
        id = _this$props3.id,
        __onChange = _this$props3.onChange,
        onMouseEnter = _this$props3.onMouseEnter,
        onMouseLeave = _this$props3.onMouseLeave,
        percentFilled = _this$props3.percentFilled,
        __readOnly = _this$props3.readOnly,
        uncheckedColor = _this$props3.uncheckedColor,
        uncheckedIcon = _this$props3.uncheckedIcon,
        _tabbable = _this$props3._tabbable;
    var hasPercentage = percentFilled != null;
    var on = this.state.checked; // If there is a percentage, than the background icon will be the unchecked icon
    // for the foreground icon to cover

    var backgroundIconUnchecked = !on || hasPercentage;
    var wrapperClassName = (0, _classnames.default)('private-form__icon-toggle', className);
    var renderedForegroundIcon = this.renderForegroundIcon({
      checkedColor: checkedColor,
      checkedIcon: checkedIcon,
      iconSize: iconSize,
      percentFilled: percentFilled
    }, {
      hasPercentage: hasPercentage
    });
    return _react.default.createElement("label", {
      className: wrapperClassName,
      onMouseLeave: onMouseLeave,
      onMouseEnter: onMouseEnter
    }, _react.default.createElement("input", {
      "aria-label": ariaLabel,
      checked: checked,
      className: (0, _classnames.default)('sr-only', 'private-form__icon-toggle__input'),
      defaultChecked: defaultChecked,
      id: id,
      type: "checkbox",
      onChange: this.handleChange,
      tabIndex: _tabbable ? '0' : '-1'
    }), _react.default.createElement(_UIIcon.default, {
      className: "private-form__icon-toggle__icon",
      color: backgroundIconUnchecked ? uncheckedColor : checkedColor,
      name: backgroundIconUnchecked ? uncheckedIcon : checkedIcon,
      role: "presentation",
      size: iconSize
    }), renderedForegroundIcon);
  }
});

exports.default = _default;
module.exports = exports.default;